module.exports = __webpack_public_path__ + "img/jane west.31013f66.png";